/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useEffect, useState } from 'react'
import Modal from '../Modal'
import { useServiceContext } from '../../root'
import { getWorkflow } from '../../services/api/workflows'
import Loader from '../shared/Loader'

interface ReadCustomJustificationModalProps {
  workflow: {
    id: number
    workflowType?: string
    justificationText?: string
  }
  onClose?: () => void
}

interface WorkflowDetails {
  justificationText?: string
  [key: string]: any
}

export const ReadCustomJustificationModal: React.FC<ReadCustomJustificationModalProps> = ({ workflow, onClose }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [loading, setLoading] = useState(false)
  const [workflowDetails, setWorkflowDetails] = useState<WorkflowDetails | null>(null)

  useEffect(() => {
    if (!workflow || !workflow.id) {
      console.error('No Workflow ID specified')
      return
    }

    if (workflow.workflowType) {
      setWorkflowDetails(workflow)
    } else {
      setLoading(true)
      getWorkflow(workflow.id)
        .then((wfData) => {
          setWorkflowDetails(wfData)
          setLoading(false)
        })
        .catch(() => {
          console.error('WF ' + workflow.id + ' not loaded')
          setLoading(false)
        })
    }
  }, [workflow])

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <Modal show={true} handleClose={handleClose} title={translate('WORKFLOW_CUSTOM_JUSTIFICATION_DESC')} size="md">
      <Modal.Body>
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <Loader blocking={loading} />
          </div>
        ) : (
          <p className="info">{workflowDetails?.justificationText || translate('NOT_AVAILABLE')}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary text-capitalize" onClick={handleClose}>
          {translate('OK')}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReadCustomJustificationModal
